module.exports = __webpack_public_path__ + "static/media/violet.f3a91731.png";